import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./adminArea.styl";
const template = require("./adminArea.vue");

@Component({
  template: template
})
export class AdminAreaComponent extends Vue {

}

Vue.component("cmHome", AdminAreaComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/adminArea/adminArea.ts